import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faAddressBook, faShieldAlt, faCheck } from '@fortawesome/free-solid-svg-icons';

// Seletor de produto (§4.1) — CRM e Cofre são experiências separadas que
// compartilham auth/tenant. Fica no topbar do CRM; o lado do Cofre ganha
// só um ponto de entrada equivalente (ver Principal.jsx), sem redesenhar
// o shell do Cofre nesta etapa.
function AppSwitcher() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('click', onClickOutside);
    return () => document.removeEventListener('click', onClickOutside);
  }, []);

  return (
    <div className="crm-dropdown" ref={ref}>
      <button className="crm-btn crm-btn-outline crm-btn-sm" onClick={() => setOpen((v) => !v)}>
        <FontAwesomeIcon icon={faAddressBook} /> CRM <FontAwesomeIcon icon={faChevronDown} />
      </button>
      {open && (
        <div className="crm-dropdown-menu">
          <div className="crm-dropdown-section-label">Produto atual</div>
          <button className="crm-dropdown-item" onClick={() => setOpen(false)}>
            <FontAwesomeIcon icon={faAddressBook} /> CRM <FontAwesomeIcon icon={faCheck} style={{ marginLeft: 'auto' }} />
          </button>
          <button className="crm-dropdown-item" onClick={() => navigate('/principal')}>
            <FontAwesomeIcon icon={faShieldAlt} /> Cofre de Senhas
          </button>
        </div>
      )}
    </div>
  );
}

export default AppSwitcher;
